import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './businessProcessingOutsource.css';

import buttonArrow from '../../assets/icons/button-arrow.svg';
import bpoHeroWide from '../../assets/bpo-hero-wide.png';
import bpoSideAgent from '../../assets/bpo-side-agent.png';
import { sendContactEmail } from '../../utils/emailjs';

const BusinessProcessingOutsource = () => {
  const navigate = useNavigate();
  const [newsletterForm, setNewsletterForm] = useState({
    name: '',
    email: '',
    introduction: '',
  });

  const handleNavigateToInquiryForm = () => {
    navigate('/sell-your-business#kw-sell-inquiry');
  };

  useEffect(() => {
    const previousBackground = document.body.style.background;
    document.body.style.background = '#FFFFFF';
    document.body.classList.add('kw__page-hide-backtotop');

    return () => {
      document.body.style.background = previousBackground;
      document.body.classList.remove('kw__page-hide-backtotop');
    };
  }, []);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setNewsletterForm((current) => ({ ...current, [name]: value }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    await sendContactEmail(newsletterForm, 'BPO Newsletter');
    setNewsletterForm({
      name: '',
      email: '',
      introduction: '',
    });
  };

  return (
    <div className="kw__bpo-page">
      <section className="kw__bpo-top kw__bpo-section">
        <p className="kw__bpo-outline">Business Process Outsourcing</p>

        <div className="kw__bpo-hero-copy">
          <h1>Optimizing Performance, Driving Global Scale</h1>
          <p>
            In a fast-paced global economy, operational agility is the ultimate competitive advantage. We provide high-performance BPO solutions
            that empower enterprises to streamline processes, optimize overheads, and scale with confidence. By merging advanced technology with
            top-tier talent, we handle complex back-office workflows and customer experience channels allowing our global partners to focus
            entirely on core strategic growth.
          </p>
        </div>
      </section>

      <section className="kw__bpo-wide-image-wrap" aria-hidden="true">
        <img src={bpoHeroWide} alt="" className="kw__bpo-wide-image" />
      </section>

      <section className="kw__bpo-black-band">
        <div className="kw__bpo-section kw__bpo-black-content">
          <h2>24/7 Operations - Quality &amp; Compliance</h2>
          <p>
            We master high-volume, continuous workflows where precision and speed are critical. Managing data integrity, multi-channel support,
            and cross-border service levels requires disciplined management and robust infrastructure. Our BPO frameworks ensure zero operational
            lag, absolute data security, and unwavering compliance under continuous market pressure.
          </p>
        </div>
      </section>

      <section className="kw__bpo-scale kw__bpo-section">
        <h2>Empowering Enterprises with Scalable Talent</h2>
        <p>
          BPO excellence is more than just handling tasks it is about how seamlessly your extended team integrates with your global business
          vision. Our focus remains on building outsourced operations that maintain absolute stability and quality under scale. We deliver
          consistent productivity, strict quality assurance (QA), and long-term reliability across diverse industry verticals. This platform is
          custom-built for global enterprises, tech startups, and international partners who know that operational efficiency is sustainable only
          when execution remains consistent day after day.
        </p>
      </section>

      <section className="kw__bpo-cta-row kw__bpo-section">
        <div className="kw__bpo-cta-copy">
          <h2>Ready to Optimize Your Operations?</h2>
          <p>
            If you are looking to scale your workflows, reduce operational friction, and secure world-class back-office or customer support
            partner with us and let&apos;s drive efficiency together.
          </p>
          <button type="button" className="kw__bpo-cta-btn" onClick={handleNavigateToInquiryForm}>
            <span>Let&apos;s Connect to Discuss</span>
            <img src={buttonArrow} alt="" />
          </button>
        </div>

        <img src={bpoSideAgent} alt="" className="kw__bpo-side-image" aria-hidden="true" />
      </section>

      <section className="kw__bpo-newsletter kw__bpo-section">
        <div className="kw__bpo-news-copy">
          <p className="kw__bpo-news-label">Newsletter</p>
          <h3>Never Miss an Update</h3>
          <p>
            Subscribe to our corporate newsletter to receive quarterly highlights, industry research, and exclusive event invitations directly to
            your inbox.
          </p>
        </div>

        <form className="kw__bpo-news-form" onSubmit={handleSubmit}>
          <div className="kw__bpo-news-row">
            <input name="name" placeholder="Name" value={newsletterForm.name} onChange={handleChange} />
            <input name="email" placeholder="Email address" value={newsletterForm.email} onChange={handleChange} />
          </div>
          <textarea name="introduction" placeholder="Introduction" value={newsletterForm.introduction} onChange={handleChange} />
          <button type="submit" className="kw__bpo-news-submit">
            <span>Submit</span>
            <img src={buttonArrow} alt="" />
          </button>
        </form>
      </section>
    </div>
  );
};

export default BusinessProcessingOutsource;
